import { render, staticRenderFns } from "./config030-f-rgb.vue?vue&type=template&id=522533f6&"
import script from "./config030-f-rgb.vue?vue&type=script&lang=js&"
export * from "./config030-f-rgb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports